(() => {
  const initialized = new WeakSet();
  const cartObservers = new WeakSet();
  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };

  const syncCart = () => {
    const open = Boolean(document.querySelector('cart-drawer[open]'));
    document.body.classList.toggle('ut-cart-open', open);
    if (open) document.body.classList.remove('ut-help-requested');
    document.querySelectorAll('cart-drawer').forEach((drawer) => {
      if (cartObservers.has(drawer)) return;
      cartObservers.add(drawer);
      new MutationObserver(syncCart).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    });
    document.dispatchEvent(new Event('ut:cart-visibility'));
  };

  const initPurchase = (root) => {
    if (initialized.has(root)) return;
    initialized.add(root);

    const bar = document.createElement('div');
    bar.className = 'ut-purchase-shortcut';
    bar.hidden = true;
    bar.innerHTML = '<div class="ut-purchase-shortcut__info"><strong></strong><span></span></div><button type="button" class="btn btn--primary">Add to cart</button>';
    document.body.append(bar);
    const button = bar.querySelector('button');
    const title = bar.querySelector('strong');
    const price = bar.querySelector('span');
    const mobile = matchMedia('(max-width: 767.98px)');
    const custom = root.matches('.sipsafe-page');
    const syncMobileOptions = () => {
      root.querySelectorAll('[data-ut-mobile-purchase-options]').forEach((options) => {
        options.open = !mobile.matches || root.dataset.requiresSellingPlan === 'true';
      });
    };
    syncMobileOptions();
    mobile.addEventListener('change', syncMobileOptions);
    const getForm = () => root.querySelector('.main-product-form');
    const getSubmit = () => getForm()?.querySelector('[name="add"]');
    const getPlan = () => getForm()?.querySelector('[name="selling_plan"]')?.value || '';
    const needsChoice = () => !getForm()?.querySelector('[name="id"]')?.value ||
      (root.dataset.requiresSellingPlan === 'true' && !getPlan());

    const update = () => {
      if (!root.isConnected) {
        bar.remove();
        observer.disconnect();
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        document.removeEventListener('ut:cart-visibility', schedule);
        document.removeEventListener('focusin', schedule);
        document.removeEventListener('focusout', schedule);
        mobile.removeEventListener('change', syncMobileOptions);
        document.body.classList.remove('ut-shortcut-visible');
        return;
      }
      const form = getForm();
      const submit = getSubmit();
      if (!form || !submit) return;
      document.body.classList.toggle('ut-purchase-enhanced', !custom || mobile.matches);
      const variant = form.querySelector('[name="id"]')?.value;
      const widget = root.querySelector(`.shopify_subscriptions_app_block[data-variant-id="${CSS.escape(variant || '')}"]`);
      const selected = widget?.querySelector('input[data-radio-type]:checked');
      const plan = getPlan();
      const frequency = selected?.closest('label')?.querySelector('.title_and_price_wrapper > span')?.textContent.trim();
      const selectedPrice = selected?.dataset.variantPrice;
      const statusEl = root.querySelector('[data-ut-purchase-status]');
      if (statusEl) {
        if (plan) {
          setText(statusEl, `Subscription · ${selectedPrice ? `${selectedPrice} per delivery · ` : ''}${frequency || 'Review delivery frequency'}`);
        } else {
          statusEl.style.display = 'none';
        }
      }
      const optionsEl = root.querySelector('[data-ut-purchase-options]');
      if (optionsEl) {
        if (!plan && !root.dataset.requiresSellingPlan) {
          optionsEl.style.display = 'none';
        } else {
          setText(root.querySelector('[data-ut-purchase-options-label]'), plan ? 'Subscription selected · View options and terms' : 'Choose a subscription');
        }
      }

      // Keep the app's actual frequency and price; clarify this ambiguous heading only.
      root.querySelectorAll('[data-ut-purchase-options] .group_name').forEach((heading) => {
        if (heading.textContent.trim() === 'Full year supply') heading.textContent = 'Regular delivery';
      });

      setText(title, root.querySelector('h1')?.textContent.replace(/\s+/g, ' ').trim() || 'Your test kit');
      const priceWrapper = root.querySelector('.ut-price .f-price, .sipsafe-price .f-price');
      const activePrice = priceWrapper?.querySelector(priceWrapper.classList.contains('f-price--on-sale') ? '.f-price__sale .f-price-item--sale' : '.f-price__regular .f-price-item--regular') || root.querySelector('.sipsafe-price');
      if (activePrice && selectedPrice) {
        const showCurrency = /\s[A-Z]{3}$/.test(activePrice.textContent.trim());
        setText(activePrice, showCurrency ? selectedPrice : selectedPrice.replace(/\s+[A-Z]{3}$/, ''));
      }
      const displayedPrice = selectedPrice || activePrice?.textContent.trim() || '';
      setText(price, `${displayedPrice}${plan ? ' · Subscription' : ''}`);
      const loading = submit.getAttribute('aria-disabled') === 'true';
      button.disabled = submit.disabled || loading;
      setText(button, loading ? 'Adding…' : submit.disabled ? 'Sold out' : needsChoice() ? 'Choose options' : 'Add to cart');

      const editing = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="submit"]):not([type="button"]), textarea, select, [contenteditable="true"]');
      const overlay = document.querySelector('cart-drawer[open], basic-modal[open], drawer-component[open], quick-view-modal[open]');
      const visible = mobile.matches && submit.getBoundingClientRect().bottom < 0 && !editing && !overlay;
      const previewBar = document.querySelector('#PBarNextFrame');
      bar.style.bottom = previewBar ? `${previewBar.getBoundingClientRect().height}px` : '';
      bar.hidden = !visible;
      document.body.classList.toggle('ut-shortcut-visible', visible);
    };

    let pending = false;
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; update(); });
    };
    const observer = new MutationObserver(schedule);
    observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value', 'class'] });
    root.addEventListener('change', schedule);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('ut:cart-visibility', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);

    button.addEventListener('click', () => {
      const submit = getSubmit();
      if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
      if (needsChoice()) {
        root.querySelector('[data-ut-purchase-options]')?.setAttribute('open', '');
        submit.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        submit.focus({ preventScroll: true });
      } else {
        // Use the original form so quantity, variant, selling plan and app properties stay intact.
        submit.click();
      }
    });
    update();
  };

  const syncHelp = () => {
    const available = Boolean(document.querySelector('#jotform-agent-preview-root .ai-agent-chat-avatar'));
    document.querySelectorAll('[data-ut-product-help]').forEach((button) => { button.hidden = !available; });
  };

  const init = () => {
    document.querySelectorAll('product-info.ut-product-modern, product-info.sipsafe-page').forEach(initPurchase);
    syncCart();
    syncHelp();
  };
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-ut-product-help]')) return;
    const avatar = document.querySelector('#jotform-agent-preview-root .ai-agent-chat-avatar');
    if (!avatar) return;
    document.body.classList.add('ut-help-requested');
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('drawer:handleAfterShow', syncCart);
  document.addEventListener('drawer:handleAfterHide', syncCart);
  const start = () => {
    init();
    new MutationObserver(syncHelp).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

// Klaviyo reviews render client-side. With no genuine reviews, the "0 reviews" star row and the
// "Customer reviews 0 / 5" panel are a negative trust signal, so hide both until a review exists.
(() => {
  const hideEmptyReviews = () => {
    const widget = document.querySelector('.klaviyo-star-rating-widget a[aria-label^="0 stars"]');
    if (!widget) return false;
    widget.closest('.product__block--\\@app, .shopify-app-block')?.setAttribute('hidden', '');
    document.querySelector('[id$="__ut_product_reviews"]')?.setAttribute('hidden', '');
    return true;
  };
  if (hideEmptyReviews()) return;
  const observer = new MutationObserver(() => { if (hideEmptyReviews()) observer.disconnect(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 15000);
})();
